import "./App.css";
import Avatar from "./components/Avatar";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import LandingPage from "./components/LandingPage";
import Phase1 from "./components/Phase1";
import Products from "./components/Products";
import Tokenomics from "./components/Tokenomics";
import Tools from "./components/Tools";
import LocomotiveScroll from "locomotive-scroll";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, useGSAP);

function App() {
  useGSAP(() => {
    const scroll = new LocomotiveScroll({
      el: document.querySelector("[data-scroll-container]"),
      smooth: true,
      multiplier: 1,
      lerp: 0.05,
      touchMultiplier: 2,
    });

    return () => {
      scroll.destroy();
    };
  }, []);

  return (
    <div className="App" data-scroll-container>
      <LandingPage />
      <Hero />
      <Avatar />
      <Tools />
      <Products />
      <Tokenomics />
      <Phase1 />
      <Footer />
    </div>
  );
}

export default App;
